import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { Box, HStack, Text, VStack } from "native-base";
import { useEffect, useState } from "react";
import { useFormContext } from "@madmedical/form";
import { useTranslation } from "@madmedical/i18n";
import SubmitButton from "../../form/SubmitButton";
import Button from "../../atoms/Button";
import ModalContent from "../../molecules/ModalContent";
import FormControl from "../../form/FormControl";
import BabyCongratulations from "../../pics/Pregnancy/BabyCongratulations";
import DateTimeInput from "../../form/DateTimeInput";
import useResponsive from "../../util/useResponsive";
const BirthCongratulationsModal = ({ onClose, onSubmitPress, isSuccess, }) => {
    useEffect(() => {
        if (isSuccess) {
            onClose();
        }
    }, [isSuccess, onClose]);
    const { isSmallScreen } = useResponsive();
    const [isValid, setIsValid] = useState(false);
    const { watch } = useFormContext();
    const babyLength = watch("length");
    const babyWeight = watch("weight");
    const babyHeadCircumference = watch("headCircumference");
    useEffect(() => {
        if (babyLength > 0 && babyWeight > 0 && babyHeadCircumference > 0) {
            setIsValid(true);
        }
        else {
            setIsValid(false);
        }
    }, [babyLength, babyWeight, babyHeadCircumference]);
    const { t } = useTranslation();
    return (_jsx(ModalContent, Object.assign({ header: t("pregnancy:yourBabyIsBorn"), footer: _jsxs(_Fragment, { children: [_jsx(Button, Object.assign({ onPress: onClose, variant: "outlined" }, { children: t("cancel") })), _jsx(SubmitButton, { onPress: onSubmitPress, label: t("save"), isDisabled: !isValid })] }) }, { children: _jsxs(VStack, Object.assign({ space: 4 }, { children: [_jsx(Box, Object.assign({ my: 1, height: 150, display: "flex", alignItems: "center" }, { children: _jsx(BabyCongratulations, {}) })), _jsx(FormControl, { label: "Gyermek neve", name: "givenName", isRequired: true, labelProps: {
                        _text: { color: "gray.800" },
                    }, height: "44px" }), _jsx(DateTimeInput, { name: "bornAt", label: "Sz\u00FClet\u00E9s id\u0151pontja", isRequired: true }), _jsxs(HStack, Object.assign({ justifyContent: "space-between", space: isSmallScreen ? 2 : 4, direction: isSmallScreen ? "column" : "row" }, { children: [_jsx(FormControl, { label: "Hossz", name: "length", labelProps: {
                                _text: { color: "gray.800" },
                            }, type: "number", height: "44px", maxLength: 4, isRequired: true, InputRightElement: _jsx(Box, Object.assign({ px: 2 }, { children: _jsx(Text, Object.assign({ color: "gray.500", fontSize: "sm" }, { children: "cm" })) })) }), _jsx(FormControl, { label: "S\u00FAly", name: "weight", labelProps: {
                                _text: { color: "gray.800" },
                            }, type: "number", height: "44px", maxLength: 4, isRequired: true, InputRightElement: _jsx(Box, Object.assign({ px: 2 }, { children: _jsx(Text, Object.assign({ color: "gray.500", fontSize: "sm" }, { children: "g" })) })) }), _jsx(FormControl, { label: "Fejk\u00F6rm\u00E9ret", name: "headCircumference", labelProps: {
                                _text: { color: "gray.800" },
                            }, type: "number", height: "44px", maxLength: 4, isRequired: true, InputRightElement: _jsx(Box, Object.assign({ px: 2 }, { children: _jsx(Text, Object.assign({ color: "gray.500", fontSize: "sm" }, { children: "cm" })) })) })] }))] })) })));
};
export default BirthCongratulationsModal;
